import { render, staticRenderFns } from "./EditOrganizationRegions.vue?vue&type=template&id=420c46ac&scoped=true"
import script from "./EditOrganizationRegions.vue?vue&type=script&lang=js"
export * from "./EditOrganizationRegions.vue?vue&type=script&lang=js"
import style0 from "./EditOrganizationRegions.vue?vue&type=style&index=0&id=420c46ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420c46ac",
  null
  
)

export default component.exports